
import SvgIcomoon from './svg/Icomoon.vue'
import spriteOptions from "./icomoon/selection.json"

// Special SVG's which won't work with IcoMoon
import SvgSpirit from './svg/Spirit.vue'

export function EoIconOptions() {
    let EoIconOptions = []

    // Custom icon names
    Object.keys(EO_CUSTOM_ICONS).forEach( iconName => EoIconOptions.push(iconName))

    // IcoMoon icon names
    spriteOptions.icons.forEach(icon => EoIconOptions.push(icon.properties.name))

    EoIconOptions.sort()
    return EoIconOptions
}

// Since we cannot use this.$options.components because of the external function above, we need to manage our own custom iconlist
export const EO_CUSTOM_ICONS = {
  'spirit': 'svg-spirit',
}

export const ICON_SIZES = Object.freeze({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: 'xxl',
  TEXT: 'text',
})

export default {
  name: 'EoIcon',
  components: {
    SvgIcomoon,
    SvgSpirit,
  },
  props: {
    /**
     * Name of the icon
     */
    href: {
      validator: prop => EoIconOptions().includes(prop) || prop === undefined || prop === null,
      required: true,
    },
    /**
     * Size of the icon: (xs) (sm) (md) (lg) (xl) (xxl) (text)
     */
    size: {
      type: String,
      validator: prop => Object.values(ICON_SIZES).includes(prop),
      default: 'sm',
    },
    /**
     * Right position of the icon for use beside other inline elements
     */
    right: {
      type: Boolean,
      default: false,
    },
    /**
     * Left position of the icon for use beside other inline elements
     */
    left: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: color of the icon
     */
    color: {
      type: String,
      default: null,
    },
  },
  computed: {
    component () {
      return this.isIcoMoonSet ? "svg-icomoon" : EO_CUSTOM_ICONS[this.href]
    },
    classes () {
      return {
        'eo-icon': true,
        [this.size]: !!this.size,
        'left': !!this.left,
        'right': !!this.right,
        ['text--' + this.color]: !!this.color,
      }
    },
    isIcoMoonSet () {
      return !Object.keys(EO_CUSTOM_ICONS).includes(this.href)
    },
  },
}
